import { action } from 'easy-peasy';
import { IActionSetIsSmoker } from '../types';

const setIsSmoker: IActionSetIsSmoker = action((state, isSmoker) => {
  state.info.isSmoker = isSmoker;
});

export default setIsSmoker;
